<!-- <template>
  <img alt="Vue logo" src="./assets/logo.png">
  <HelloWorld msg="Welcome to Your Vue.js App"/>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    HelloWorld
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style> -->

<template>
  <v-app align="center" v-bind:style="{ backgroundColor: BG_COLOR_MAIN }">
      <router-view />
  </v-app>
</template>

<script setup>
import {
  // provide,
  onBeforeMount,
  onMounted,
  onUpdated,
  onUnmounted
} from "vue";
// import { router } from "./routes/router";
import { faLog, BG_COLOR_MAIN } from "./common/faCommon.js";

onBeforeMount(() => {
  faLog(0, "[App] [onBeforeMount]");
});

onMounted(() => {
  faLog(0, "[App] [onMounted]");
});

onUpdated(() => {
  faLog(0, "[App] [onUpdated]");
});

onUnmounted(() => {
  faLog(0, "[App] [onUnmounted]");
});

</script>

<!-- <style>
.custom-scroll {
    overflow-y: auto;
    margin-right: 10px;
}

.custom-scroll::-webkit-scrollbar {
    width: 10px;
    margin-right: 10px;
}

.custom-scroll::-webkit-scrollbar-track {
    background-color: #556b2f80;
    border-radius: 15px;
}

.custom-scroll::-webkit-scrollbar-thumb {
    background-color: #2e8b57bb;
    border-radius: 15px;
}
</style> -->
